// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body[data-v-32d665f6]{background-color:#fff;color:#5c5c5c;font-size:12px}", ""]);
// Exports
module.exports = exports;
